/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CabinClassType,
    CabinClassTypeFromJSON,
    CabinClassTypeFromJSONTyped,
    CabinClassTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface CabinClassTypeFilterItemOutput
 */
export interface CabinClassTypeFilterItemOutput {
    /**
     * 
     * @type {string}
     * @memberof CabinClassTypeFilterItemOutput
     */
    displayText?: string | null;
    /**
     * 
     * @type {CabinClassType}
     * @memberof CabinClassTypeFilterItemOutput
     */
    value?: CabinClassType;
    /**
     * 
     * @type {boolean}
     * @memberof CabinClassTypeFilterItemOutput
     */
    isEffective?: boolean;
}

export function CabinClassTypeFilterItemOutputFromJSON(json: any): CabinClassTypeFilterItemOutput {
    return CabinClassTypeFilterItemOutputFromJSONTyped(json, false);
}

export function CabinClassTypeFilterItemOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): CabinClassTypeFilterItemOutput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'displayText': !exists(json, 'displayText') ? undefined : json['displayText'],
        'value': !exists(json, 'value') ? undefined : CabinClassTypeFromJSON(json['value']),
        'isEffective': !exists(json, 'isEffective') ? undefined : json['isEffective'],
    };
}

export function CabinClassTypeFilterItemOutputToJSON(value?: CabinClassTypeFilterItemOutput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'displayText': value.displayText,
        'value': CabinClassTypeToJSON(value.value),
        'isEffective': value.isEffective,
    };
}


